<script lang="ts" setup>
import { ref } from 'vue';
import { useUserStore } from '../../../stores/user';
import { IconWorld } from '@tabler/icons-vue';
import { IconLogout } from '@tabler/icons-vue';
import { IconLogin } from '@tabler/icons-vue';
import { useI18n } from 'vue-i18n';
import { useLocaleStore } from '../../../stores/locale';

const t = useI18n().t;
const userStore = useUserStore();
const culture = ref(localStorage.getItem('locale') || 'ar');
const localeStore = useLocaleStore();
const mobileMenuOpen = ref("");
const user = async () => {
  await userStore.getUser();
};
user();
defineProps({
  logo: {
    type: String,
    default: 'logo.png',
  },
});
const logout = async () => {
  await userStore.logout();
  //remove all cookies
  document.cookie.split(';').forEach(c => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
  //remove all local storage
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('calculatorCart');
  //remove all session storage
  sessionStorage.clear();
  //redirect to login page
  window.location.href = '/login';
};
const toggleCulture = () => {
  culture.value = localStorage.getItem('locale') || 'ar';
  const newCulture = culture.value === 'en' ? 'ar' : 'en';
  localStorage.setItem('locale', newCulture);
  window.location.reload();
};

const closeMobileMenu = () => {
  mobileMenuOpen.value = "";
  document.body.style.overflow = "auto";
};
</script>
<template>
  <!-- header -->
  <div class="header">
    <div class="header-bottom-bar">
      <div class="container">
        <div class="bottom-bar">
          <div class="two-bar">
            <div class="d-flex align-items-center justify-content-between">
              <div class="logo" style="min-height: 90px;min-width: 110px;">
                <router-link :to="'/'" class="logo-link">
                  <img alt="logo" v-if="logo" :src="logo ?? '../../../assets/img/logo.png'" width="110px"
                    height="60px" />
                </router-link>
              </div>
            </div>
          </div>
          <a href="JavaScript:void(0)" id="mobile-menu" class="menu-start" @click="mobileMenuOpen == 'open' ? '' : 'open'">
            <i class="fa-solid fa-bars"></i>
          </a>
          <nav class="navbar" :dir="localeStore.locale == 'ar' ? 'rtl' : 'ltr'">
            <router-link :to="'/'" class="navbar-brand text-white menu-item"
              :class="{ active: $router.currentRoute.value.name == 'home' }">
              <span>{{ t('Home') }}</span>
            </router-link>
            <router-link :to="'/about'" class="navbar-brand text-white menu-item"
              :class="{ active: $router.currentRoute.value.name == 'about' }">
              <span>{{ t('About Us') }}</span>
            </router-link>
            <router-link :to="'/projects'" class="navbar-brand text-white menu-item" :class="{
              active: $router.currentRoute.value.name == 'our-projects',
            }">
              <span>{{ t('Projects') }}</span>
            </router-link>
            <router-link :to="'/services'" class="navbar-brand text-white menu-item" :class="{
              active: $router.currentRoute.value.name == 'our-services',
            }">
              <span>{{ t('Services') }}</span>
            </router-link>
            <router-link :to="'/admin'" v-if="userStore.user.id != null && userStore.user.ly <= 10"
              class="navbar-brand text-white menu-item">
              <span class="">{{ t('Admin Panel') }}</span>
            </router-link>
            <div class="flex mx-10">
              <!--login / register-->
              <div class="header-login">
                <a href="#" @click="logout" v-if="userStore.user && userStore.user.id != null"
                  class="item-btn flex items-center">
                  <IconLogout stroke="{2}" />
                  {{ t('Logout') }}
                </a>
                <router-link :to="'/login'" v-if="!userStore.user || userStore.user.id == null"
                  class="item-btn flex items-center">
                  <IconLogin stroke="{2}" />
                  <span class="fs-6">{{ t('Login') }}</span>
                </router-link>
              </div>
              <a href="#" @click="toggleCulture" class="item-btn flex items-center">
                <IconWorld stroke="{2}" />
                <span class="text-2xl">{{ culture == 'ar' ? 'En' : 'ع' }}</span>
              </a>
            </div>
          </nav>
          <div class="header-search gap-1">
            <a href="/#design-your" class="theme-btn w-color">
              {{ t('Request a Quote') }}
            </a>
            <a href="/#estimation-calculator" class="theme-btn w-color">
              {{ t('Estimation Calculator') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div :class="'mobile-nav overflow-hidden '+ mobileMenuOpen" id="mobile-nav">
      <div class="res-log">
        <a href="index.html">
          <img alt="logo" src="../../../assets/img/logo.png" width="110px" height="60px" />
        </a>
      </div>
      <div class="flex flex-col justify-between gap-9 align-items-center h-50">
        <div class="d-flex flex-column items-center gap-3">
          <a href="/" class="navbar-brand text-white menu-item">
            <span>{{ t('Home') }}</span>
          </a>
          <router-link :to="'/about'" class="navbar-brand text-white menu-item">
            <span>{{ t('About Us') }}</span>
          </router-link>
          <router-link :to="'/projects'" class="navbar-brand text-white menu-item">
            <span>{{ t('Projects') }}</span>
          </router-link>
          <router-link :to="'/services'" class="navbar-brand text-white menu-item">
            <span>{{ t('Services') }}</span>
          </router-link>
          <router-link :to="'/admin'" v-if="userStore.user.id != null && userStore.user.ly <= 10"
            class="navbar-brand text-white menu-item">
            <span class="">{{ t('Admin Panel') }}</span>
          </router-link>
          <a href="JavaScript:void(0)" name="closeMobileSideMenu" id="closeMobileSideMenu" @click="closeMobileMenu"></a>
        </div>
        <div class="header-login flex justify-content-between w-full">
          <!--login / register-->
          <a href="#" @click="toggleCulture" class="item-btn">
            <svg class="w-6 h-6 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m13 19 3.5-9 3.5 9m-6.125-2h5.25M3 7h7m0 0h2m-2 0c0 1.63-.793 3.926-2.239 5.655M7.5 6.818V5m.261 7.655C6.79 13.82 5.521 14.725 4 15m3.761-2.345L5 10m2.761 2.655L10.2 15" />
            </svg>
          </a>

          <a href="#" @click="logout" v-if="userStore.user && userStore.user.id != null"
            class="login-btn flex gap-1 items-center">
            <svg class="w-[32px] h-[32px] text-white dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
                clip-rule="evenodd" />
            </svg>
            {{ t('Logout') }}
          </a>
          <router-link :to="'/login'" v-if="!userStore.user || userStore.user.id == null"
            class="login-btn flex gap-1 items-center">
            <svg class="w-[32px] h-[32px] text-gray-800 dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
                clip-rule="evenodd" />
            </svg>
            <span>{{ t('Login') }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  background-image: url(../../../../../assets/img/background-2.jpg);
  /* style="background-image: url(&quot;../../../../../assets/img/bg-two.jpg&quot;);" */
  background-size: cover;
  background-position: center;
}

.header-login {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.header-login .login-btn {
  color: #fff;
  text-decoration: none;
  transition: background-color 0.3s ease;
  font-size: 0.9rem;
  border-radius: 5px;
  padding: 5px 10px;
}

.login-btn:hover {
  background-color: #9b7455;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
}

.item-btn {
  color: #fff;
  text-decoration: none;
  transition: background-color 0.3s ease;
  font-size: 0.9rem;
  border-radius: 5px;
  padding: 5px 10px;
}

.item-btn:hover {
  background-color: #9b7455;
  color: #fff;
  border-radius: 5px;
}

.header-login-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #4f5460;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 1000;
  color: #fff;
  padding: 10px;
}

.header-login:hover .header-login-dropdown {
  display: block;
}

.header-login-dropdown .account-dropdown {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}

.account-dropdown {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-width: 10vw;
}

.account-dropdown li a {
  color: #fff;
  margin: 5px 0;
}

.account-dropdown li a:hover {
  color: #9b7455;
  text-decoration: none;
}

.header-search {
  margin-left: 20px;
}

.menu-item span {
  position: relative;
  display: inline-block;
  font-size: 1.2rem;
  border-radius: 5px;
  padding: 5px 10px;
}

.menu-item span:hover {
  background-color: #9b7455;
  color: #fff;
  border-radius: 5px;
}

.menu-item.active {
  background-color: #9b7455;
  color: #fff;
  border-radius: 5px;
}
</style>
